import { mapState, mapGetters } from 'vuex';

const adminMixin = {
  computed: {
    ...mapState({
      currentAdmin: (state) => state.admin.current,
      showActionModal: (state) => state.admin.showActionModal,
      actionModalView: (state) => state.admin.actionModalView,
      partnerList: (state) => state.admin.partnerList,
      imageForm: (state) => state.admin.imageForm,
      showRightSidebar: (state) => state.admin.showRightSidebar,
      adminFilter: (state) => state.admin.adminFilter,
      watchlistData: (state) => state.admin.watchlistData,
      selectedCorpId: (state) => state.admin.adminFilter.corpId,
    }),
    ...mapGetters([
      'adminRole',
      'isSmacAdmin',
      'allBranches',
    ]),
  },
};

export default adminMixin;
